import { ICellRendererParams } from "ag-grid-community";
import capitalize from "lodash.capitalize";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { CountryEnum } from "@intelligems/ig-types/schemas/shopify";
import { theme } from "@src/theme";

export const CompareInnerRenderer = (
  props: ICellRendererParams & { tabValue: number }
) => {
  const node = props.node;
  return (
    <IgTypography
      sx={{
        fontWeight: 600,
      }}
    >
      {props.tabValue === 5 && node.key !== null && node.key !== "Other"
        ? `${CountryEnum[node.key]} (${node.key})`
        : props.tabValue === 7
          ? capitalize(node.key)
          : node.key === "Youtube"
            ? "YouTube"
            : node.key === "New"
              ? "New Visitors"
              : node.key === "Returning"
                ? "Returning Visitors"
                : node.key}
    </IgTypography>
  );
};
